import React, {PureComponent} from 'react';
import {UncontrolledCarousel} from 'reactstrap';
import PropTypes from 'prop-types';

import airLiquide from './logos/airLiquide.png';
import bnp from './logos/bnp.png';
import lvmh from './logos/lvmh.png';
import sg from './logos/sg.png';
import stellantis from './logos/stellantis.png';
import transdev from './logos/transdev.png';

import './References.scss';

const references = [
  {imgAlt: 'Stellantis', imgSrc: stellantis},
  {imgAlt: 'LVMH', imgSrc: lvmh},
  {imgAlt: 'BNP Paribas', imgSrc: bnp},
  {imgAlt: 'Air Liquide', imgSrc: airLiquide},
  {imgAlt: 'Transdev', imgSrc: transdev},
  {imgAlt: 'Société Générale', imgSrc: sg},
];

export default class References extends PureComponent {
  static propTypes = {
    className: PropTypes.string
  };

  static defaultProps = {
    className: ''
  };

  render() {
    return <section className={`references ${this.props.className}`}>
      <h2 className="mb-4">Ils nous font confiance</h2>
      <div className="row d-none d-md-flex justify-content-center align-items-center py-5">
        {references.map(reference => (
          <div className="img-wrapper" key={reference.imgAlt}>
            <img className="w-100" alt={reference.imgAlt} src={reference.imgSrc}/>
          </div>
        ))}
      </div>
      <UncontrolledCarousel
        className="d-md-none"
        controls={true}
        indicators={true}
        items={references.map(reference => (
          {altText: reference.imgAlt, caption: reference.imgAlt, src: reference.imgSrc.src}
        ))}
      />
    </section>;
  }
}
